import { ConfigModel } from 'shared/models'
import * as Yup from 'yup'

function getValidations() {
  return Yup.object().shape({
    title: Yup.string().required('Поле обязательно для заполнения'),
    description: Yup.string().required('Поле обязательно для заполнения'),
    phone: Yup.string(),
    giftCardPrices: Yup.array().of(
      Yup.number().required('Поле обязательно для заполнения').min(1, 'Значение должно быть больше 0')
    )
  }) as Yup.ObjectSchema<NonNullable<ConfigModel>, Yup.AnyObject>
}

export { getValidations }
